"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var noop_1 = require("rxjs/util/noop");
// don't shorten this and alike imports
var plugged_controls_model_1 = require("../../../../layout-models/form-models/plugged-controls.model");
var form_dragula_options_1 = require("../form-dragula-options");
require("./form-control-panel.component.scss");
var form_settings_model_1 = require("./form-settings.model");
var sub_form_settings_model_1 = require("./sub-form-settings.model");
var ng2_dragula_1 = require("ng2-dragula");
var FormControlPanelComponent = /** @class */ (function () {
    function FormControlPanelComponent(moduleRegistryService, languageService, currentLanguageProvider, dragulaService) {
        this.moduleRegistryService = moduleRegistryService;
        this.languageService = languageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.dragulaService = dragulaService;
        this.formEntityTypeEnum = idm_dynamic_layout_interpreter_1.FormEntityType;
        this.dragulaOptions = new form_dragula_options_1.FormDragulaOptions();
    }
    FormControlPanelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.controlModel = new plugged_controls_model_1.PluggedControlsModel();
        this.dragulaService.setOptions('userHelpItems', {
            revertOnSpill: true,
        });
        this.data$ = this.moduleRegistryService.availableControls().pipe(operators_1.map(function (metaControls) {
            return metaControls.filter(function (control) {
                return skynet_store_utilities_1.notNil(control.settings) && !control.isFieldBound;
            });
        }), operators_1.switchMap(function (metaControls) {
            _this.controlModel.createTreeFromControls(metaControls);
            if (_this.formEntityType) {
                return combineLatest_1.combineLatest(_this.languageService.getAvailableLanguages(), _this.currentLanguageProvider.getCurrentLanguage()).pipe(operators_1.map(function (_a) {
                    var languages = _a[0], currentLanguage = _a[1];
                    return ({
                        languages: languages,
                        currentLanguage: currentLanguage,
                    });
                }));
            }
            return of_1.of({
                languages: undefined,
                currentLanguage: undefined,
            });
        }), operators_1.tap(noop_1.noop, console.error));
    };
    FormControlPanelComponent.prototype.ngOnDestroy = function () {
        this.dragulaService.destroy('userHelpItems');
    };
    FormControlPanelComponent.prototype.addUserHelpItem = function () {
        this.formSettings.userHelpItems.push({
            title: idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder().build(),
            url: '',
            documentId: -1,
        });
    };
    FormControlPanelComponent.prototype.deleteUserHelpItem = function (index) {
        this.formSettings.userHelpItems.splice(index, 1);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], FormControlPanelComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", form_settings_model_1.FormSettingsModel)
    ], FormControlPanelComponent.prototype, "formSettings", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", sub_form_settings_model_1.SubFormSettingsModel)
    ], FormControlPanelComponent.prototype, "subFormSettings", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], FormControlPanelComponent.prototype, "workflowFormSettings", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FormControlPanelComponent.prototype, "isHeaderExists", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FormControlPanelComponent.prototype, "isTabBarExists", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], FormControlPanelComponent.prototype, "formEntityType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FormControlPanelComponent.prototype, "isSubwayMapExists", void 0);
    FormControlPanelComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'form-control-panel',
            template: require('./form-control-panel.component.html'),
        }),
        __param(0, core_1.Inject(idm_dynamic_layout_interpreter_1.formModuleRegistryKey)),
        __metadata("design:paramtypes", [idm_dynamic_layout_interpreter_1.ModuleRegistryService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            ng2_dragula_1.DragulaService])
    ], FormControlPanelComponent);
    return FormControlPanelComponent;
}());
exports.FormControlPanelComponent = FormControlPanelComponent;
//# sourceMappingURL=form-control-panel.component.js.map